<lib-main-menu [color]="color">
  <ng-container left>
    <picture class="mr2">
      <source srcset="assets/images/logo.svg" type="image/svg+xml" />
      <source srcset="assets/images/logo.png" type="image/png" />
      <source srcset="assets/images/logo.jpg" type="image/jpeg" />
      <source srcset="assets/images/logo.jpeg" type="image/jpeg" />
      <img src="assets/images/logo.svg" height="28px" class="block" />
    </picture>
  </ng-container>

  <ng-container right
    ><button mat-icon-button><mat-icon>notification_important</mat-icon></button>

    <button mat-button>
      <mat-icon class="mr1">account_circle</mat-icon>{{ authService.getUserData().given_name }}
      {{ authService.getUserData().family_name }}
    </button>

    <button mat-button (click)="onLogout()">
      <mat-icon class="mr1">exit_to_app</mat-icon>Odhlásit
    </button></ng-container
  >
</lib-main-menu>
